import axios from 'axios';
export default class CoinService {
    // async getBannerList(typ, stat, sdate, edate) {
    //     return await axios
    //         .post(`/admin/banner`, {
    //             type: typ,
    //             status: stat,
    //             startDate: sdate,
    //             endDate: edate,
    //             // sortBy: 'id',
    //             // sortOrder: 'desc',
    //         })
    //         .then((res) => res.data.data.banners)
    //         .catch((err) => {
    //             if(err.statusCode==='401'){
    //                 window.location.href = '/login';
    //             }
    //         });
    // }
    async getCoinList(data) {
        return await axios .post('/api/v1/admin/chodan-coin/list', data);
    }
    async viewCoin(id) {
        return await axios.get(`/api/v1/admin/chodan-coin/details/${id}`).then((result) => result.data.result[0]);
    }
    async updateCoin(formdata) {
        return await axios.post(`/api/v1/admin/chodan-coin/edit`, formdata).then((res) => res);
    }
}
